var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.04183 8.58677V5.37371C6.04183 4.28004 6.45887 3.23115 7.2012 2.45781C7.94353 1.68446 8.95035 1.25 10.0002 1.25C11.05 1.25 12.0568 1.68446 12.7991 2.45781C13.5415 3.23115 13.9585 4.28004 13.9585 5.37371M17.9168 10.5026V9.96134C17.9168 9.59678 17.7778 9.24715 17.5304 8.98937C17.2829 8.73159 16.9473 8.58677 16.5974 8.58677H10.0002H3.40294C3.053 8.58677 2.7174 8.73159 2.46995 8.98937C2.22251 9.24715 2.0835 9.59678 2.0835 9.96134V17.3754C2.0835 17.74 2.22251 18.0896 2.46995 18.3474C2.7174 18.6052 3.053 18.75 3.40294 18.75H16.5974C16.9473 18.75 17.2829 18.6052 17.5304 18.3474C17.7778 18.0896 17.9168 17.74 17.9168 17.3754V16.0009V10.5026Z",
    stroke: "#0e0333",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6854 13.4009C11.6854 14.3087 10.9452 15.0487 10.027 15.0487C9.1088 15.0487 8.36865 14.3087 8.36865 13.4009C8.36865 12.4932 9.1088 11.7532 10.027 11.7532C10.9452 11.7532 11.6854 12.4932 11.6854 13.4009Z",
    stroke: "#0e0333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenLockIcon);
export default __webpack_public_path__ + "static/media/open-lock-icon.faa9af9906e3b03e08361237437d2b5b.svg";
export { ForwardRef as ReactComponent };